/* eslint-disable @typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';

xplenty.controller('ComponentEditorTransformationController', [
  '$scope',
  '$rootScope',
  '$timeout',

  function ($scope, $rootScope, $timeout) {
    let componentNameValid = false;
    let componentFormValid = false;
    $scope.isComponentValid = function () {
      $timeout(function () {
        const valid = componentNameValid && componentFormValid;

        $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, !valid);
      });
    };

    $scope.onValidityChange = (value) => {
      componentFormValid = value;
      $scope.isComponentValid();
    };

    $scope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      componentNameValid = valid;
      $scope.isComponentValid();
    });
  },
]);
